import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { DragDropContext, Draggable, Droppable, DropResult, DroppableStateSnapshot, DraggableProvided, DraggableStateSnapshot, DroppableProvided } from 'react-beautiful-dnd';

import produce from 'immer';
import update from 'immutability-helper';

import { RootState } from '../../modules';
import { editContent } from '../../modules/editor';

import FieldSection from './FieldSection';
import Select from '../../components/Dropdown/Select';

import check from '../../assets/images/icon/check.png';
import checked from '../../assets/images/icon/checked.png';
import dragHandle from '../../assets/images/icon/dragHandle.png';

type Props = {
	selectedContentId: number;
	currentContent: any;
}

function SelectedContentShare({ selectedContentId, currentContent }: Props) {
	const [items, setItems] = useState([
		{ id: 0, label: '공유하기', value: 'facebook', active: false, alt: '페이스북' },
		{ id: 1, label: '게시하기', value: 'twitter', active: false, alt: '플랫폼 X' },
		{ id: 2, label: '웹에서 보기', value: 'web', active: false, alt: '링크' },
		{ id: 3, label: '공유하기', value: 'linkedin', active: false, alt: '링크드인' },
	] as any);

	const labelMapping = (value:string) => {
		const labels:any = {
			facebook: '페이스북 공유하기',
			twitter: 'X 게시하기',
			web: '웹에서 보기',
			linkedin: '링크드인 공유하기'
		}
		return labels[value];
	}

	const dispatch = useDispatch();

	const editor = useSelector((state: RootState) => state.editor);

	const currentContentStyle = currentContent?.content?.style?.[0];
	const styleTarget = `${selectedContentId}/style/0`;

	useEffect(() => {	
		const currentShareContents = currentContent?.content.content[0].share;
		const newMergedShareContents = items.map((item) => {
			const matchedItem = currentShareContents.find((i) => item.id === i.id);
			return matchedItem ? { ...item, active: matchedItem.active } : item;
		});
		setItems(newMergedShareContents);		
	}, [currentContent]);


	const onToggleColumnItem = (item: any) => {
		const activeItems = items.filter((item:any) => item.active);
		if (activeItems.length === 1 && item.active) {
			return;
		}
		
		let nextData = produce(items, (draft:any) => {
			draft.map((el:any) => {
				if (el.value === item.value) {
					el.active = !item.active;
				}
			})
		});	

		dispatch(editContent({ target: `${selectedContentId}/content/0/share`, data: nextData }));
	}

	const moveEnd = (items:any) => {
		let nextData: any = produce(items, (draft: any) => {})

		dispatch(editContent({ target: `${selectedContentId}/content/0/share`, data: nextData }));
	}

	const reOrder = (list: any, startIndex: any, endIndex: any) => {
		const result = Array.from(list);
		const [removed] = result.splice(startIndex, 1);
		result.splice(endIndex, 0, removed);
		setItems(result);
		moveEnd(result);
	};

	const onDragEnd = (result: any) => {
		// dropped outside the list(리스트 밖으로 드랍한 경우)
		if (!result.destination) {
			return;
		}

		reOrder(
			items,
			result.source.index,
			result.destination.index
		);
	}

	const getItemStyle = (draggableStyle: any, isDragging: any) => ({
		// some basic styles to make the items look a bit nicer(아이템을 보기 좋게 만드는 몇 가지 기본 스타일)
		userSelect: 'none',
		// padding: grid * 2,
		// marginBottom: grid,
		// height: 100,

		// change background colour if dragging(드래깅시 배경색 변경)
		// background: isDragging ? 'lightgreen' : 'grey',
		boxShadow: isDragging ? '0 0 10px 0 rgba(0,0,0,.4)' : 'none',

		// styles we need to apply on draggables(드래그에 필요한 스타일 적용)
		...draggableStyle
	});
	
	return (
		<div className="editor-sidebar-selected-content-setting">
			<h3 className="field-section-title">버튼 스타일</h3>
			<FieldSection
				labelName=""
				label={false}
			>
				<Select
					target={`${styleTarget}/box/snsStyle`}
					value={currentContentStyle?.box.snsStyle}
					options={editor.option.shareStyle}
					size="full"
				/>
			</FieldSection>

			<h3 className="field-section-title">공유 항목</h3>
			<div className="inner-content-sort">
				<DragDropContext
					onDragEnd={onDragEnd}
				>
					<Droppable droppableId="layoutsort">
						{(provided: DroppableProvided, snapshot: DroppableStateSnapshot) => (
							<div
								{...provided.droppableProps}
								ref={provided.innerRef}
							>
								{items.map((item: any, index: number) => (
									<div key={item.id} >
										<Draggable
											index={index}
											key={item.id}
											draggableId={`${item.id}`}
										>
											{
												(provided, snapshot) => (
													<div
														className="inner-content-sort-item"
														ref={provided.innerRef}
														{...provided.draggableProps}
														style={getItemStyle(
															provided.draggableProps.style,
															snapshot.isDragging
														)}
													>
														<div
															{...provided.dragHandleProps}
															className="drag-handle"
														>
															<img src={dragHandle} alt="dragHandle" width="6" />
														</div>

														<button
															onClick={() => { onToggleColumnItem(item) }} className="toggle"
														>
															{
																item.active ? (
																	<img src={checked} alt="check" width="22" />
																) : (
																		<img src={check} alt="check" width="22" />
																	)
															}
															{labelMapping(item.value)}
														</button>
													</div>
												)
											}
										</Draggable>
									</div>
								))}
								{provided.placeholder}
							</div>
						)}
					</Droppable>
				</DragDropContext>
			</div>
		</div>
	);
}

export default SelectedContentShare;